<template>
  <div
    class="schedule-page"
    v-featureflow:isOn="'capacity-planner-schedule-page'"
  >
    <div class="container">
      <Schedule :configuration="configuration" :workloadTasks="workloadTasks" />
    </div>
  </div>
</template>

<script>
import Schedule from "./ScheduleComponent.vue";
export default {
  name: "SchedulePage",
  components: {
    Schedule,
  },
  props: {
    configuration: {
      type: Object,
      required: true,
    },
    workloadTasks: {
      type: Map,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  min-height: 50vh;
}
</style>
